import {colors} from '../../colors/colors';

import type {ButtonVariant} from './icon-only-button';

export const getIconColor = (isDisabled: boolean, isActive: boolean, variant: ButtonVariant) => {
    if (isDisabled) {
        return colors.greyLt;
    }

    if (variant === 'danger') {
        return colors.rose;
    }

    if (isActive) {
        if (variant === 'orange') {
            return colors.orange;
        }

        return colors.grey;
    }

    return colors.greyLt;
};
